import React from "react";

export function PobleCV() {
  return (
    <span className="font-bold">
      POB<span className="text-green-600">LE</span><span className="text-gray-400"><sup className="text-2xs">CV</sup></span>
    </span>
  );
}
